// @ts-strict-ignore
import { Grid, Row, Vstack } from "components/layout/Grid";
import { ContentContainer } from "components/layout/Layout";
import styled from "styled-components";
import { Body, Heading } from "components/parts/Typography";

export const Footer = styled(ContentContainer)``;

export const Container = styled(Grid)``;

export const FooterContainer = styled(Vstack)`
  padding: 80px 0;
`;

export const MainText = styled(Heading).attrs({ size: "xl" })`
  margin: ${({ oneLine, noMargin }) =>
    noMargin ? "0" : oneLine ? "0 0 40px 0" : "0 0 8px 0"};
  ${({ theme }) => theme.media.desktop`
    margin: ${({ oneLine, noMargin }) => (noMargin ? "0" : oneLine ? "0 0 48px 0" : "0 0 16px 0")};
  `}
`;

export const SubTitle = styled(Body).attrs({ size: "lg" })`
  margin: 0 0 24px 0;
  ${({ theme }) => theme.media.desktop`
    margin: 0 0 32px 0;
  `}
`;

export const FooterRow = styled(Row)`
  margin-bottom: 0;
`;
